import { createStyle } from '@gluestack-style/react';

export const ModalFooter = createStyle({
  p: '$4',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexWrap: 'wrap',
});
